export default "/_next/static/images/3733b166e9612e762f28645c8ffff533.jpg";